// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import minusIcon from "@/assets/icons/minus.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MinusIconProps = Omit<IconProps, "name">;

export function MinusIcon(props: MinusIconProps): React.ReactNode {
  return <Icon name={minusIcon} {...props} />;
}
